// extracted by mini-css-extract-plugin
export var avatarContainer = "Avatar-module--avatar-container--qGSc8";
export var avatarName = "Avatar-module--avatar-name--aR1yR";
export var avatarPosition = "Avatar-module--avatar-position--wz5in";